import { render, staticRenderFns } from "./BulkUpdater.vue?vue&type=template&id=28daa1ff&scoped=true"
import script from "./BulkUpdater.vue?vue&type=script&lang=js"
export * from "./BulkUpdater.vue?vue&type=script&lang=js"
import style0 from "./BulkUpdater.vue?vue&type=style&index=0&id=28daa1ff&prod&scoped=true&lang=css"
import style1 from "./BulkUpdater.vue?vue&type=style&index=1&id=28daa1ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28daa1ff",
  null
  
)

export default component.exports